import React from 'react';
import { Link } from 'react-router-dom';
import LoginTextField from '../elements/editors/mui/LoginTextField';
import { isValidEmail } from '../../lib/ValidationUtils';
import { ROUTE_RESET_PASSWORD } from '../../constants/pathnames';
import { Button } from 'new/elements/Button';

class LoginForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isInputValid: this._getIsInputValid(props),
    };

    this._handleEmailChanged = this._handleEmailChanged.bind(this);
    this._handlePasswordChanged = this._handlePasswordChanged.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.email !== prevProps.email || this.props.password !== prevProps.password) {
      this.setState({
        isInputValid: this._getIsInputValid(this.props),
      });
    }
  }

  render() {
    return (
      <form onSubmit={this.props.onSubmit}>
        <div className="signup-form-item">
          <LoginTextField
            required
            type="email"
            label="Email Address"
            autoComplete="username"
            value={this.props.email ? this.props.email : ''}
            autoFocus={true}
            onChange={this._handleEmailChanged}
            data-testid="email"
          />
        </div>
        <div className="signup-form-item password-field-container">
          <LoginTextField
            required
            type="password"
            label="Password"
            autoComplete="current-password"
            value={this.props.password ? this.props.password : ''}
            onChange={this._handlePasswordChanged}
            data-testid="password"
          />
          <Link
            to={ROUTE_RESET_PASSWORD}
            style={{ color: 'var(--color-greyscale-400)' }}
            className="forgot-password-link"
          >
            Forgot Password?
          </Link>
        </div>
        <Button
          variant="contained"
          color="primary"
          style={{ width: '100%' }}
          data-testid="login-button"
          type="submit"
        >
          Log in
        </Button>
      </form>
    );
  }

  _handleEmailChanged(event) {
    this.props.onInputChanged('email', event.target.value);
  }

  _handlePasswordChanged(event) {
    this.props.onInputChanged('password', event.target.value);
  }

  _getIsInputValid(props) {
    const { email, password } = props;
    return Boolean(isValidEmail(email) && password && password.length > 0);
  }
}

export default LoginForm;
